import { Component, HostListener, Input, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import * as saveAs from 'file-saver';
import { CorporateAccountDto } from 'src/app/domain/models/dto/corporate-account.dto';
import { OrdersService } from 'src/app/shared/services/orders.service';

@Component({
  selector: 'app-company-details',
  templateUrl: './company-details.component.html',
  styleUrls: ['./company-details.component.scss'],
})
export class CompanyDetailsComponent implements OnInit {
  isMobile: boolean = false;
  private readonly notifier: NotifierService;
  @Input() cpoData: CorporateAccountDto;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkWindowSize();
  }

  constructor(
    private readonly ordersService: OrdersService,
    notifierService: NotifierService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit() {
    this.checkWindowSize();
  }

  checkWindowSize() {
    this.isMobile = window.innerWidth <= 820;
  }

  downloadAttachmentByName(fileName: string) {
    this.ordersService.downloadDocuments(fileName).subscribe({
      next: (data: any) => {
        saveAs(data, fileName);
        this.notifier.notify(
          'success',
          'Download do arquivo realizado com sucesso.'
        );
      },
      error: (err) => {
        this.notifier.notify('error', 'Erro ao efetuar o download do arquivo.');
      },
    });
  }
}
